import React from 'react';
import { Row, Col, CustomInput, Button, UncontrolledTooltip, FormGroup, Label, Input, Badge } from 'reactstrap';
import stripebutton from '../../img/light-on-light@2x.png';
import Authorization from '../Base/Authorization';
import { FormattedMessage } from 'react-intl';


//#region Gateway Details
export const RenderShift4Details = ({paymentGateway, handleChange, toggleAccessTokenModal}) => {
    return (
        <>
            <FormGroup row className="align-items-center">
                <Label sm={3}>
                    <FormattedMessage id="PaymentManagement.AccountId" />
                </Label>
                <Col sm={9}>
                    <Input 
                        type="text"
                        maxLength="50" 
                        name="userId"
                        value={paymentGateway?.userId || ''} 
                        onChange={evt => handleChange(evt)} 
                        required 
                    />
                </Col>
            </FormGroup>
            <FormGroup row className="align-items-center">
                <Label sm={3}>
                    <FormattedMessage id="PaymentManagement.PublicKey" />
                </Label>
                <Col sm={9}>
                    <Input 
                        type="text" 
                        maxLength="100" 
                        name="publishableKey" 
                        id="publishableKey" 
                        value={paymentGateway?.publishableKey || ''} 
                        onChange={evt => handleChange(evt)} 
                        required 
                    />
                </Col>
            </FormGroup>
            <FormGroup row className="align-items-center">
                <Label sm={3}>
                    <FormattedMessage id="PaymentManagement.PrivateKey" />
                </Label>
                <Col>
                    <Input 
                        type="password" 
                        maxLength="100" 
                        name="accessToken" 
                        id="accessToken" 
                        value={paymentGateway?.id ? '••••••••••••••••••••••••••••••••••' : paymentGateway?.accessToken || ''} 
                        onChange={evt => handleChange(evt)} 
                        required 
                        disabled={paymentGateway?.id}
                    />
                </Col>
                {paymentGateway?.id ?
                    <Col sm={1} className="text-right">
                        <SetKeyButton onClickFunc={toggleAccessTokenModal} id="setShift4Key" />
                    </Col>
                : ''}
            </FormGroup>
        </>
    )
}

export const RenderReduniqDetails = ({ paymentGateway, handleChange, toggleAccessTokenModal }) => {
    return (
        <>
            <FormGroup row className="align-items-center">
                <Label sm={3}>
                    <FormattedMessage id="PaymentManagement.ApiUser" />
                </Label>
                <Col sm={9}>
                    <Input
                        type="text"
                        maxLength="50"
                        name="userId"
                        value={paymentGateway?.userId || ''}
                        onChange={evt => handleChange(evt)}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup row className="align-items-center">
                <Label sm={3}>
                    <FormattedMessage id="PaymentManagement.ApiPassword" />
                </Label>
                <Col>
                    <Input
                        type="password"
                        maxLength="100"
                        name="accessToken"
                        id="reduniqAccessToken"
                        autoComplete="new-password"
                        value={paymentGateway?.id ? '••••••••••••••••••••••••••••••••••' : paymentGateway?.accessToken || ''}
                        onChange={evt => handleChange(evt)}
                        required
                        disabled={paymentGateway?.id}
                    />
                </Col>
                {paymentGateway?.id ?
                    <Col sm={1} className="text-right">
                        <SetKeyButton onClickFunc={toggleAccessTokenModal} id="setReduniqKey" />
                    </Col>
                : ''}
            </FormGroup>
        </>
    )
}

export const RenderStripeDetails = (props) => {
    const { paymentGateway } = props;

    return (
        <>
            {
                paymentGateway === undefined || paymentGateway === null || paymentGateway.userId === null ? 
                    <Row className="mb-2">
                        <Col>
                            <a href={`https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENTID}&scope=read_write&redirect_uri=${window.location.origin}/PaymentManagement`}><img height="30px" src={stripebutton}></img></a>
                        </Col>
                    </Row>
                    : 
                    <>
                        <Row className="mb-2">
                            <Col className="col-4">
                                <FormattedMessage id="PaymentManagement.StripeUserId" />
                            </Col>
                            <Col className="col-8">
                                {paymentGateway.userId}
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-4">
                                <FormattedMessage id="PaymentManagement.ConnectedOn" /> 
                            </Col>
                            <Col className="col-8">
                                {paymentGateway.createdAt}
                            </Col>
                        </Row>
                    </>
            }
        </>
    )
}
//#endregion


//#region Buttons
export const ToggleStatusButton = ({ isActive, onClickFunc, id }) => {
    return (
        <Authorization
            perform="paymentManagement:disable"
            yes={() => (
                <div>
                    <Button className="btn btn-host btn-sm ml-2" onClick={() => onClickFunc()} id={id}>
                        <i className="fa-solid fa-power-off" />
                    </Button>
                    <UncontrolledTooltip placement="bottom" target={id}>
                        {isActive ? <FormattedMessage id="PaymentManagement.DisableGateway" /> : <FormattedMessage id="PaymentManagement.EnableGateway" />}
                    </UncontrolledTooltip>
                </div>
            )}
            no={() => <div></div>}
        />
    )
}

export const SaveButton = ({ onClickFunc }) => {
    return (
        <Authorization
            perform="paymentManagement:save"
            yes={() => (
                <div>
                    <Button className="btn btn-host btn-sm ml-2" onClick={() => onClickFunc()} >
                        <i className="fa-solid fa-floppy-disk" />
                    </Button>
                </div>
            )}
            no={() => <div></div>}
        />
    )
}

export const SetKeyButton = ({ onClickFunc, id }) => {
    return (
        <Authorization
            perform="paymentManagement:save"
            yes={() => (
                <div>
                    <Button className="btn btn-host btn-sm ml-2" onClick={() => onClickFunc()} id={id}>
                        <i className="fa-solid fa-key" />
                    </Button>
                    <UncontrolledTooltip placement="bottom" target={id}>
                        {<FormattedMessage id="PaymentManagement.SetKey" />}
                    </UncontrolledTooltip>
                </div>
            )}
            no={() => <div></div>}
        />
    )
}
//#endregion


//#region Common
export const RenderValidPaymentMethods = (props) => {
    const { validPaymentModes, updateValidPaymentModes, selectedMethods } = props;

    return (
        <div className="mb-2 mt-4">
            <Row>
                <Col>
                    <h6>
                        <FormattedMessage id="PaymentManagement.ValidPaymentModes" />
                    </h6>
                </Col>
            </Row>
            <hr className="mt-1 mb-2" />
            <Row className='mt-2'>
                {validPaymentModes?.map((mode, key) =>
                    <Col key={key} className="col-4">
                        <CustomInput type="checkbox" id={mode.value} name={mode.value} checked={selectedMethods?.some(pm => pm === mode.value) ? true : false} onChange={e => updateValidPaymentModes(e, key)}>
                            {mode.img(30)}
                            <span className="ml-2 align-top">{mode.label}</span>
                        </CustomInput>
                    </Col>
                )}
            </Row>
        </div>
    )
};

export const RenderPaymentStatus = ({ paymentGateways, gateway }) => {
    let p = paymentGateways && paymentGateways.find(el => el.code === gateway.code);

    return (
        <>
            {
                p !== undefined && p !== null ?
                    <>
                        <i className=" color-host fa-solid fa-check" />
                        <br />
                        {
                            p.active === true ?
                                <Badge className="btn-host ">
                                    <FormattedMessage id="PaymentManagement.Active" />
                                </Badge>
                                :
                                <Badge color="secondary">
                                    <FormattedMessage id="PaymentManagement.Disabled" />
                                </Badge>
                        }
                    </>
                    :''
            }
        </>
    )
}
//#endregion